<template>
  <div class="login-box">
    <div class="float-box">
      <h2 class="title">检验报告查询</h2>
      <form action="">
        <p>
          <label>账号</label
          ><input type="text" placeholder="请输入账号" v-model="user" />
        </p>
        <p>
          <label>密码</label
          ><input type="password" placeholder="请输入密码" v-model="password" />
        </p>
        <!-- <p><input type="checkbox"><label>记住密码</label></p> -->
        <p><button type="button" @click="login">登录</button></p>
      </form>
    </div>
    <div class="keeponrecord">
      <div>
        <a
          href="https://beian.miit.gov.cn/"
          style="text-decoration: none; display: block"
          ><p class="article1">冀ICP备2021024845号-1</p></a
        >
      </div>
      <div style="display: flex; flex-warp: nowarp">
        <p class="keepimg"></p>
        <p class="article">冀公网安备13040302001316号</p>
      </div>
    </div>
  </div>
</template>
<script>
var toast;
export default {
  data() {
    return {
      user: "",
      password: "",
    };
  },
  mounted() {
    if (localStorage.getItem("User") != null) {
      var User = JSON.parse(localStorage.getItem("User"));
      this.user = User.user;
      this.password = User.password;
    }
  },
  methods: {
    login() {
      var that = this;
      if (toast) {
        toast.close();
      }
      if (this.user.length == 0) {
        toast = this.$Toast({
          message: "账号不能为空！",
          duration: 1000,
        });
      } else if (this.password.length == 0) {
        toast = this.$Toast({
          message: "密码不能为空！",
          duration: 1000,
        });
      } else {
        this.$Loading.open("正在登录");
        var params = { UserCode: this.user };
        this.$axios
          .get("/api/MyLis/SelectUserInfoForUserCode", { params: params })
          .then(function (res) {
            that.$Loading.close();
            if (res.data == -1) {
              toast = that.$Toast({
                message: "用户名不存在！",
                duration: 1000,
              });
            } else if (res.data.Table[0].userpassword) {
              if (res.data.Table[0].userpassword == that.password) {
                if (res.data.Table[0].userisuse != "-1") {
                  toast = that.$Toast({
                    message: "登录成功",
                    duration: 1000,
                  });
                  var User = { user: that.user, password: that.password };
                  localStorage.setItem("User", JSON.stringify(User));
                  setTimeout(() => {
                    var {
                      usercode,
                      username,
                      unitcode,
                      unitname,
                      unitproperty,
                    } = res.data.Table[0];
                    that.$router.push({
                      path: "/home",
                      query: {
                        username: username,
                        usercode: usercode,
                        unitcode: unitcode,
                        unitname: unitname,
                        unitproperty: unitproperty,
                      },
                    });
                  }, 2000);
                } else {
                  toast = that.$Toast({
                    message: "此账户暂不可用",
                    duration: 1000,
                  });
                }
              } else {
                toast = that.$Toast({
                  message: "密码错误！",
                  duration: 1000,
                });
              }
            }
          })
          .catch(function () {
            that.$Loading.close();
          });
        // setTimeout(() => {

        // }, 2000);
      }
    },
  },
};
</script>
<style scoped>
.login-box {
  width: 100vw;
  height: 100vh;
  background-image: url("../assets/background1.jpg");
  background-size: 100vw 100vh;
  padding-top: 0.9rem;
  box-sizing: border-box;
}
.float-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.title {
  font-size: 0.26rem;
  font-weight: 500;
  letter-spacing: 0.08rem;
  margin-bottom: 0.5rem;
}
.float-box p {
  font-size: 0;
  margin-bottom: 0.2rem;
}
.float-box p label {
  font-size: 16px;
  margin-right: 0.1rem;
  letter-spacing: 0.05rem;
}
.float-box p input {
  box-sizing: border-box;
  font-size: 14px;
  padding: 5px 5px;
  border-radius: 6px;
  border: 1px solid rgb(226, 151, 38);
}
.float-box p button {
  float: right;
  width: 0.75rem;
  height: 0.35rem;
  /* line-height: 0.45rem; */
  text-align: center;
  border-radius: 10px;
  color: #fff;
  font-size: 0.16rem;
  font-weight: 400;
  letter-spacing: 0.05rem;
  background-color: rgb(49 172 195);
  border: 1px solid rgb(226, 151, 38);
}
.float-box p button:active {
  background-color: rgb(36 146 167);
}
.keeponrecord {
  /* display: flex;
  flex-direction: column;
  align-items: center; */
  position: fixed;
  bottom: 15px;
  left: 50%;
  margin-left: -95px;
}
.keeponrecord div .keepimg {
  background-image: url("../assets/keeponrecord.jpg");
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
}
.keeponrecord div .article {
  font-size: 6px;
}
.keeponrecord div .article1 {
  font-size: 6px;
  color: #000;
  text-align: center;
}
</style>